export const name = 'cocoen';
export const componentName = `${name}-component`;
